module.exports = __webpack_public_path__ + "media/images/new-white-logo-76875a3132cb0fbc309ca41196e80d28.png";